export enum Platform {
  LINUX = 1,
  WINDOWS,
}
